import AdminClient from '../client/AdminClient';
import _ from "lodash";
import {mapIds} from "../../../helpers/utils";

class ContactDraftService {
    static async index(session, params) {
        const filterParams = this.parsedContactFilterParams(params.filterParams);
        return AdminClient.get(`/v1/admin/contact_drafts`, session,
            {
                ...params,
                filterParams: filterParams,
            }
        );
    }

    static async new(session) {
        return AdminClient.get(`/v1/admin/contact_drafts/new`, session);
    }

    static async create(session, params) {
        return AdminClient.post(`/v1/admin/contact_drafts/`, session, this.parsedContactDraft({...params, status: "pending", draft_type: "create"}));
    }

    static async update(contactId, session, params) {
        return AdminClient.put(`/v1/admin/contact_drafts/${contactId}`, session, this.parsedContactDraft({...params, draft_type: "update"}));
    }

    static async edit(contactId, session) {
        return AdminClient.get(`/v1/admin/contact_drafts/${contactId}/edit`, session);
    }

    static async show(contactId, session) {
        return AdminClient.get(`/v1/admin/contact_drafts/${contactId}`, session);
    }

    static async delete(contactId, session) {
        return AdminClient.delete(`/v1/admin/contact_drafts/${contactId}`, session);
    }

    static async changeLog(contactId, session) {
        return AdminClient.get(`/v1/admin/contact_drafts/${contactId}/change_log`, session);
    }

    static async notes(contactId, session) {
        return AdminClient.get(`/v1/admin/contact_drafts/${contactId}/notes`, session);
    }

    static async uploadAvatar(contactId, session, file) {
        const formData = new FormData();
        formData.append('avatar', file);
        return AdminClient.uploadFile(`/v1/admin/contact_drafts/${contactId}/upload_avatar`, session, formData);
    }

    static async approve(contactId, session) {
        return AdminClient.post(`/v1/admin/contact_drafts/${contactId}/approve`, session);
    }

    static async reject(contactId, session) {
        return AdminClient.post(`/v1/admin/contact_drafts/${contactId}/reject`, session);
    }

    static async updateNested(contactId, session, params) {
        return AdminClient.put(`/v1/admin/contact_drafts/${contactId}`, session, this.parsedNestedContactDraft({...params, draft_type: "update"}));
    }

    static parsedContactDraft(contactDraft) {
        return {
            ...contactDraft,
            universities_ids: contactDraft.universities?.map(({university_id}) => (university_id)),
            contact_universities_attributes: contactDraft.universities?.map(({id, university_id, start_year, end_year, _destroy}) => ({
                id,
                university_id,
                start_date: start_year ? `${start_year}-01-01` : start_year,
                end_date: end_year ? `${end_year}-01-01` : end_year,
                _destroy
            })),
            companies_ids: contactDraft.companies?.map(({display_id}) => (display_id)),
            company_contact_drafts_attributes: contactDraft.companies?.map(({id, display_id, start_year, end_year, _destroy}) => ({
                id,
                display_id,
                start_date: start_year ? `${start_year}-01-01` : start_year,
                end_date: end_year ? `${end_year}-01-01` : end_year,
                _destroy
            })),
            contact_responsibilities_ids: contactDraft.responsibilities?.map(responsibility => responsibility.id)
        };
    }

    static parsedNestedContactDraft(contactDraft) {
        return {
            ...contactDraft,
            universities_ids: contactDraft.universities?.map(({university_id}) => (university_id)),
            contact_universities_attributes: contactDraft.universities?.map(({id, university_id, start_year, end_year, _destroy}) => ({
                id,
                university_id,
                start_date: start_year ? `${start_year}-01-01` : start_year,
                end_date: end_year ? `${end_year}-01-01` : end_year,
                _destroy
            })),
            companies_ids: contactDraft.companies?.map(({display_id}) => (display_id)),
            company_contact_drafts_attributes: contactDraft.companies?.map(({id, display_id, start_year, end_year, _destroy}) => ({
                id,
                display_id,
                start_date: start_year ? `${start_year}-01-01` : start_year,
                end_date: end_year ? `${end_year}-01-01` : end_year,
                _destroy
            })),
        };
    }

    static parsedContactFilterParams(params) {
        if (!_.isEmpty(params)) {
            return {
                ...params,
                researchers: mapIds(params.researchers),
                investors: mapIds(params.investors),
                genders: mapIds(params.genders),
                titles: mapIds(params.titles),
                companies: mapIds(params.companies),
                universities: mapIds(params.universities),
                responsibilities: mapIds(params.responsibilities),
                statuses: mapIds(params.statuses),
                types: mapIds(params.types),
                stages: mapIds(params.stages),
            }
        } else {
            return params;
        }
    }
}

export default ContactDraftService;